"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstantCell = exports.LocalDateTimeCell = exports.LocalDateCell = void 0;
const react_1 = require("react");
const inline_table_field_cells_1 = require("../../../components/inline-table-field/inline-table-field-cells");
function LocalDateCell({ collectionDatakey, ...props }) {
    const Cell = inline_table_field_cells_1.InlineTableFieldCells.useInlineDateFieldFactory({
        ...props,
        representation: 'local-date',
        collectionDatakey,
    });
    return (0, react_1.useMemo)(() => Cell, [collectionDatakey]);
}
exports.LocalDateCell = LocalDateCell;
function LocalDateTimeCell({ collectionDatakey, ...props }) {
    const Cell = inline_table_field_cells_1.InlineTableFieldCells.useInlineDateFieldFactory({
        ...props,
        representation: 'local-date-time',
        collectionDatakey,
    });
    return (0, react_1.useMemo)(() => Cell, [collectionDatakey]);
}
exports.LocalDateTimeCell = LocalDateTimeCell;
function InstantCell({ collectionDatakey, ...props }) {
    const Cell = inline_table_field_cells_1.InlineTableFieldCells.useInlineDateFieldFactory({
        ...props,
        representation: 'instant',
        collectionDatakey,
    });
    return (0, react_1.useMemo)(() => Cell, [collectionDatakey]);
}
exports.InstantCell = InstantCell;
//# sourceMappingURL=date-cell.js.map